/*
CONFIG FILE STRUCT and ARGUMENTS
`envx.config.json`
{
  "input": "./examples/.envx", // Path to your .envx file
  "outputs": {
    "env": "./examples/.env", // Output .env file path
    "types": "./examples/envx.ts", // Output TypeScript definition file
    "metaFilePath": "./examples" // Folder where meta JSON will be placed (file name is fixed)
  },
  "overwrite": true // If true, existing .env will be overwritten without prompt
}


input -> Specifies the path to the .envx file
outputs -> used to specify output files
  env -> Used to specify the path of the .env file to be converted from .envx
  types -> to specify the path to the typescript type file to create
  [NEW] metaFilePath -> It is a json file with type etc. data to be created with .env during build, only the folder pathh name can be specified.
overwrite (true/false) -> If .env is present at the time of conversion and the value is true, it is overwritten directly, no questions asked 

*/

import path from "path";
import { existsSync, readFileSync } from "fs";
import { JSON_CONFIG_FILE_NAME } from "./constants";

export const defaultUserConfig = {
  input: "./.envx",
  outputs: {
    env: "./.env",
    types: "./types/envx.ts",
    metaFilePath: ".",
  },
  overwrite: false,
};

function isValidUserConfig(obj: any): obj is Partial<typeof defaultUserConfig> {
  return (
    obj &&
    typeof obj === "object" &&
    typeof obj.input === "string" &&
    (obj.outputs === undefined ||
      (typeof obj.outputs === "object" &&
        (obj.outputs.env === undefined ||
          typeof obj.outputs.env === "string") &&
        (obj.outputs.types === undefined ||
          typeof obj.outputs.types === "string") &&
        (obj.outputs.metaFilePath === undefined ||
          typeof obj.outputs.metaFilePath === "string"))) &&
    (typeof obj.overwrite === "boolean" || obj.overwrite === undefined)
  );
}

export function loadUserConfig() {
  const jsonPath = path.resolve(JSON_CONFIG_FILE_NAME);

  if (existsSync(jsonPath)) {
    const raw = readFileSync(jsonPath, "utf-8");

    try {
      const parsed_config = JSON.parse(raw);

      if (isValidUserConfig(parsed_config)) {
        return {
          ...defaultUserConfig,
          ...parsed_config,
          outputs: {
            ...defaultUserConfig.outputs,
            ...parsed_config.outputs,
          },
        };
      } else {
        console.warn(
          `[envx:info:config] Invalid config structure, falling back to default.`
        );
        return defaultUserConfig;
      }
    } catch (err) {
      const errMsg = err instanceof Error ? err.message : String(err);
      console.warn(
        `[envx:warn:config] Could not parse ${JSON_CONFIG_FILE_NAME}: ${errMsg}`
      );
      return defaultUserConfig;
    }
  }

  return defaultUserConfig;
}
